module.exports = __webpack_public_path__ + "static/media/mulher-startup.a819f415.png";